import { render } from "./HeaderTemplate.vue?vue&type=template&id=636d2e1f&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"

import "./HeaderTemplate.vue?vue&type=style&index=0&id=636d2e1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636d2e1f"]])

export default __exports__